import { FormControl, TextField } from '@mui/material';
import { ChangeEventHandler } from 'react';

export const UsernameField: React.FC<{
  username: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}> = ({ username, onChange }) => {
  return (
    <FormControl className="provision-field">
      <TextField
        id="username"
        label="Username"
        value={username}
        name={'username'}
        onChange={onChange}
        fullWidth
        variant="outlined"
        placeholder="Enter database username"
        helperText="Username for database authentication"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
          },
        }}
      />
    </FormControl>
  );
};
